import { Sun, CloudSun, CloudRain, Snowflake, type LucideIcon } from "lucide-react";
import { C, FONT, hexA } from "../theme";
import type { ForecastCell, ForecastIcon } from "../types";

const iconMap: Record<ForecastIcon, LucideIcon> = {
  sun: Sun,
  "cloud-sun": CloudSun,
  rain: CloudRain,
  snow: Snowflake,
};

/** 24h forecast strip — six cells on wide, three on narrow; rain cells tinted ice. */
export function Forecast({ cells }: { cells: ForecastCell[] }) {
  return (
    <div
      className="marram-forecast"
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)",
        gap: 10,
      }}
    >
      <style>{`@media (min-width: 560px){.marram-forecast{grid-template-columns:repeat(6,1fr) !important}}`}</style>
      {cells.map((cell, i) => {
        const wet = cell.rainMm > 0;
        const Icon = iconMap[cell.icon];
        return (
          <div
            key={i}
            style={{
              textAlign: "center",
              padding: "12px 8px",
              borderRadius: 14,
              background: wet ? hexA(C.ice, 0.08) : C.paper,
              border: `1px solid ${wet ? hexA(C.ice, 0.28) : C.lineSoft}`,
            }}
          >
            <div style={{ fontFamily: FONT.mono, fontSize: 11.5, color: C.textLow }}>
              {cell.t}
            </div>
            <Icon
              size={20}
              style={{ margin: "6px auto", color: wet ? C.ice : C.textMid }}
            />
            <div style={{ fontFamily: FONT.mono, fontSize: 13, color: C.ink }}>
              {cell.tempC}°
            </div>
            {wet && (
              <div
                style={{
                  fontFamily: FONT.mono,
                  fontSize: 11,
                  color: C.ice,
                  marginTop: 2,
                }}
              >
                {cell.rainMm}mm
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
